module.exports = __webpack_public_path__ + "img/series_4.51682a68.png";